import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { filter, Observable, Subscription } from 'rxjs';
import { MapHelperService } from 'src/services/map-helper.service';
import { ToastrService } from 'ngx-toastr';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { AvailabilityDTO } from '../../../../../map-features/sections/locations-section/models/AvailabilityDTO';
import { AvailabilityService } from '../../../../../map-features/sections/locations-section/services/Availability.service';
import { PanelInternalLayerService } from '../../../../../map-features/sections/locations-section/services/Panel-Internal-Layer.service';
import { EnumFeaturesActionsDestinations } from 'src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations';
import { PolygonDrawToolService } from 'src/services/maps/features/PolygonDrawTool.service';
import { environment } from "src/environments/environment";
import { ToolCarsSelectorService } from '../../../services/Tool-Cars-Selector.service';

@Component({
  selector: 'tool-cars-selector',
  templateUrl: './tool-cars-selector.component.html',
  styleUrls: ['./tool-cars-selector.component.css'],
  animations: [
    trigger("mostrarLista", [
      state("visible", style({  opacity: 1, transform: "translateY(0)",  height: "*" })),
      state("hidden", style({ opacity: 0, transform: "translateY(100%)", height: '0px', overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
  ],
})
export class ToolCarsSelectorComponent {

  isAvailabilityButton: boolean = false;
  listaIntersectVisible: boolean = false;

  intersectedFeatures: any;
  $intersectedFeatures : Observable<any> = new Observable<any>();
  $isAvailabilityButton : Observable<boolean> = new Observable<boolean>();
  subscription_GetFeatures: Subscription;
  subscription_GetisAvailabilityButton: Subscription;
  subscription_InsertAvailabilities: Subscription;


  constructor(
    private MapHelper: MapHelperService,
    private polygonDrawToolService: PolygonDrawToolService,
    public toolCarsSelectorservice: ToolCarsSelectorService,
    public availabilityService: AvailabilityService,
    private toastrService : ToastrService,
    private notifyService: SwalNotificationService,
    private interLayerService: PanelInternalLayerService
  ) {
    // this.$intersectedFeatures = this.MapHelper.featuresInsideArea$;
    this.subscription_GetFeatures = this.MapHelper.featuresInsideArea$.pipe(
      filter(data => data && data.featureCollection.features.length > 0 && data.destination == EnumFeaturesActionsDestinations.Tool)
    ).subscribe(data => {
      this.intersectedFeatures = data.featureCollection.features;
    });
    this.$isAvailabilityButton = this.toolCarsSelectorservice.getAvailabilityButton();
    this.subscription_GetFeatures = this.$isAvailabilityButton.subscribe(data => {
      this.isAvailabilityButton = data;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription_GetFeatures)
      this.subscription_GetFeatures.unsubscribe();
    if (this.subscription_GetisAvailabilityButton)
      this.subscription_GetisAvailabilityButton.unsubscribe();
    if (this.subscription_InsertAvailabilities)
      this.subscription_InsertAvailabilities.unsubscribe();
  }

  //funciones de intersect
  onClickIntersect() {
    if (!this.toolCarsSelectorservice.isCarSelectionToolVisible) {
      this.OpenTool();
    }else{
      this.CloseTool();
    }
  }

  submitAvailability(){
    if (this.toolCarsSelectorservice.startDate != null || this.toolCarsSelectorservice.endDate != null) {
      const availabilityList : AvailabilityDTO[] = [];
      this.intersectedFeatures.forEach(element => {
        availabilityList.push({
          idLocation: 0,
          identifier: element.properties._Id,
          startDate: this.toolCarsSelectorservice.startDate,
          endDate: this.toolCarsSelectorservice.endDate,
          description: "",
          id: 0
        });
      });
      this.notifyService.confirmMessage(
        "Apartar los siguientes activos del "+ this.toolCarsSelectorservice.startDate.getDate()+"/"+this.toolCarsSelectorservice.startDate.getMonth() + "/"+ this.toolCarsSelectorservice.startDate.getFullYear() + 
        " al "+ this.toolCarsSelectorservice.endDate.getDate()+"/"+this.toolCarsSelectorservice.endDate.getMonth() + "/"+ this.toolCarsSelectorservice.endDate.getFullYear()  ,
         "Se agregaran ["+this.intersectedFeatures.length + "]  elementos").then((result) => {
        if (result.value) {
          this.subscription_InsertAvailabilities = this.availabilityService.InsertRange(availabilityList).subscribe({
            next: (data) => {
              if (data.isSuccess) {
                this.toastrService.success("Disponibilidad registrada correctamente");
                this.CloseTool();
              }else{
                // this.toastrService.error("Error al registrar disponibilidad");
                Sentry.captureMessage('ToolCarsSelector.submitAvailability: isSuccess false', { level: 'warning', extra: { response: data } });
              }
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error al insertar disponibilidades', error);
              this.toastrService.error("Error al registrar disponibilidad");
            }
          });
        }
      });
      
    }
    
  }

  OpenTool(){
    // this.toolCarsSelectorservice.isExternalLayersVisible = false;
    // this.toolCarsSelectorservice.isInternalLayersVisible = false;
    this.toolCarsSelectorservice.isCarSelectionToolTipVisible = true;
    this.toolCarsSelectorservice.isCarSelectionToolVisible = true;
    var activeLayers = this.interLayerService.GetSelectedLayers();
    this.notifyService.showCustomSuccess(
      "",
      "Selecciona varios puntos en el mapa para crear la SELECCIÓN DE UNIDADES. Para finalizar da click derecho sobre el mapa."
    );
    if(!environment.production) console.log("toggleToolMainLayerIntersectDrawControl", this.MapHelper.isSourceEmpty('filterPointsSource'));
    if (this.MapHelper.isSourceEmpty('filterPointsSource')) {
      this.polygonDrawToolService.toggleToolMainLayerIntersectDrawControl(true);
      this.polygonDrawToolService.drawIntersectToolPolygon.deleteAll();
      this.polygonDrawToolService.drawIntersectToolPolygon.changeMode('draw_polygon');
    }else{
      this.polygonDrawToolService.toggleToolFilterLayerIntersectDrawControl(true);
      this.polygonDrawToolService.drawIntersectToolPolygon.deleteAll();
      this.polygonDrawToolService.drawIntersectToolPolygon.changeMode('draw_polygon');
    }
  }

  CloseTool(){
    this.toolCarsSelectorservice.isCarSelectionToolVisible = false;
    this.intersectedFeatures = [];
    this.polygonDrawToolService.toggleToolMainLayerIntersectDrawControl(false);
  }

}
